import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from './constants';

const lazy = {
    DashboardPage: lazyLoad(async () => {
        const { DashboardPage } = await import('./Dashboard');

        return { default: DashboardPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'navigation.dashboard',
        page: lazy.DashboardPage,
        path: route.patterns.dashboard,
    },
];
